/** Monthly attendance sheet (PRD M05-05): persons × days grid from latest-per-day records; feeds the Excel export. */
export const ATTENDANCE_LETTER = { present: "P", absent: "A", leave: "C", sick: "M", mission: "Mi", half_day: "½" };
export function buildAttendanceSheet(team, records, month) {
    const [y, m] = month.split("-").map(Number);
    const count = new Date(y, m, 0).getDate();
    const days = Array.from({ length: count }, (_, i) => `${month}-${String(i + 1).padStart(2, "0")}`);
    const rows = team.map((p) => {
        const mine = records.filter((r) => r.person_id === p.person_id);
        const dayMap = {};
        let present = 0, absent = 0, hours = 0;
        for (const r of mine) {
            dayMap[r.date] = ATTENDANCE_LETTER[r.status] ?? "?";
            if (r.status === "present" || r.status === "mission")
                present++;
            if (r.status === "half_day")
                present += 0.5;
            if (r.status === "absent")
                absent++;
            hours += Number(r.hours ?? 0);
        }
        return { person_id: p.person_id, name: p.name_fr, days: dayMap, present, absent, hours };
    });
    return { days, rows };
}
//# sourceMappingURL=attendance-sheet.js.map